import { LineChartComponent } from './line-chart/line-chart.component';

export const COMPONENTS = [
  LineChartComponent,
];

export * from './line-chart/line-chart.component';
